// Internal dependencies
import { appStyles } from '../App.styles';
// BrandVoices styles
export const brandVoicesStyles = {
    textButton: Object.assign(Object.assign({}, appStyles.text14), { color: '#006C49', padding: '0.625rem 0.75rem', textTransform: 'none', margin: '0 0 0 0.5rem' }),
    cell: {
        fontWeight: '400',
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        letterSpacing: '0.25px',
        color: '#000000',
        whiteSpace: 'nowrap',
    },
};
